// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__V7g2B","inner":"footer_inner__QCBZX","links":"footer_links__ESUQW"};